// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/MajorWishList/MajorDetail.less
// module id = 937
// module chunks = 0